import { render, staticRenderFns } from "./RsaAccettazioneSchedeValutazioneIngressoComponent.vue?vue&type=template&id=5588fdc5"
import script from "./RsaAccettazioneSchedeValutazioneIngressoComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneSchedeValutazioneIngressoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports